import { Grid, Paper, Typography } from "@mui/material";
import {
  componentSpace,
  componentSpaceMobile,
  styles,
} from "../../../theme/styles";
import logo from "../../../medias/discord.png";
import { colors } from "../../../theme";
import { useMediaQuery, useTheme } from "@mui/material";

export const Roadmap = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <Grid
      item
      md={6}
      xs={12}
      style={
        isDesktop
          ? {
              marginTop: componentSpace,
              padding: 0,
            }
          : {
              marginTop: componentSpaceMobile,
              padding: 0,
            }
      }
    >
      <Paper
        style={styles.roadMapPaper}
        onMouseEnter={(e) => (e.currentTarget.style.borderColor = "white")}
        onMouseLeave={(e) =>
          (e.currentTarget.style.borderColor = "transparent")
        }
      >
        <img src={logo} style={styles.roadMapLogo} alt="Try in Discord" />
        <Typography style={{ fontSize: 16 }}>Discord Bot</Typography>
      </Paper>

      <Paper
        style={{
          ...styles.roadMapPaper,
          backgroundColor: colors.background.tertiary,
        }}
      >
        <img style={styles.roadMapLogo} alt="" />
        <div>
          <Typography style={{ fontSize: 16 }}>Aplicativo</Typography>
          <Typography style={{ fontSize: 12 }}>Em breve</Typography>
        </div>
      </Paper>

      <Paper
        style={{
          ...styles.roadMapPaper,
          backgroundColor: colors.background.tertiary,
        }}
      >
        <img style={styles.roadMapLogo} alt="" />
        <div>
          <Typography style={{ fontSize: 16 }}>Marktplace</Typography>
          <Typography style={{ fontSize: 12 }}>Em breve</Typography>
        </div>
      </Paper>
    </Grid>
  );
};
